import store from '../../../../store/store';
import { isMobileDevice } from '../../../../util/deviceDetection';
import { toolsConfig } from './toolsConfig';
import { mprAnnotationsOptions } from './ToolOptions/AnnotationsOptions';
import { getOrderedToolNamesByDevice, filterAndOrderToolsByNamesList, loadRotationTools, loadZoomTools, TYPE_TOOLSET_3D } from './toolsetUtils';
import toolNames from './toolNames';


const showLayoutToolCondition = (layout) => (!layout.is3DModeEnabled && !layout.isMPRModeEnabled);
const showVRToolCondition = (layout) => {
  if (!layout.is3DModeEnabled) return false;
  if (layout.activeViewportContext?.viewType) {
    return layout.activeViewportContext.viewType === 'vr';
  }
  return layout.selectedViewIndex === 8 || isMobileDevice();
};
const showMPRPalettesToolCondition = (layout) => !showVRToolCondition(layout) || layout.isMPRModeEnabled;
const showSLToolCondition = (layout) => {
  const selectedViewIndex = layout.activeViewportContext?.viewIndex ?? layout.selectedViewIndex;
  return layout.isMPRModeEnabled || (!isMobileDevice() && layout.is3DModeEnabled && [0, 3, 6].includes(selectedViewIndex));
};
const showMPRAnnotationsToolCondition = (layout) => (
  layout.isMPRModeEnabled ||
  layout.is3DModeEnabled ||
  layout.activeViewportContext?.viewType === 'mpr' ||
  layout.elements?.[layout.selectedViewIndex]?.initOptions?.viewType?.type === 'mpr'
);
const showMPRReferenceToolsCondition = (layout) => (
  layout.isMPRModeEnabled
  || (layout.is3DModeEnabled && (
    layout.elements?.some((element) => element?.initOptions?.viewType?.type === 'mpr')
    || layout.activeViewportContext?.mode === '3d'
  ))
);

const showTool = (toolName, layout) => {
  switch (toolName) {
    case toolNames.LAYOUT:
      return showLayoutToolCondition(layout);
    case toolNames.MODE_MPR:
      return layout.is3DModeEnabled;
    case toolNames.MODE_3D:
      return layout.isMPRModeEnabled;
    case toolNames.CLIPPING:
    case toolNames.PALETTES_VR:
      return showVRToolCondition(layout);
    case toolNames.PALETTES:
      return showMPRPalettesToolCondition(layout);
    case toolNames.CROSS_REFERENCE:
      return showMPRReferenceToolsCondition(layout);
    case toolNames.REF_LINES:
      return showMPRReferenceToolsCondition(layout);
    case toolNames.INTENSITY:
      return showSLToolCondition(layout);
    case toolNames.ANNOTATIONS:
      return showMPRAnnotationsToolCondition(layout);
    default:
      return true;
  }
}

const filterToolsetBy3DConditions = (toolset, layout) => {
  return toolset.filter((tool) => {
    return showTool(tool.name, layout);
  });
};


export const getToolset3D = (layoutOverride) => {
  const layout = layoutOverride || store.getState().layout;
  const rotationTool = loadRotationTools();
  loadZoomTools();

  const toolset3DOrderedNames = [...getOrderedToolNamesByDevice(TYPE_TOOLSET_3D)];

  if (layout.isMPRModeEnabled) {
    const rotateIndex = toolset3DOrderedNames.indexOf(toolNames.ROTATE);
    const panIndex = toolset3DOrderedNames.indexOf(toolNames.PAN);

    if (rotateIndex !== -1 && panIndex !== -1) {
      toolset3DOrderedNames.splice(rotateIndex, 1);
      toolset3DOrderedNames.splice(panIndex + 1, 0, toolNames.ROTATE_MENU);
    }

    rotationTool.groupedTools = rotationTool.groupedTools.filter((tool) => (
      [
        toolNames.ROTATE,
        toolNames.ROTATE270,
        toolNames.ROTATE90,
        toolNames.HFLIP,
        toolNames.VFLIP,
        toolNames.RESET_POSITION,
      ].includes(tool.name)
    ));
  }
  
  const filteredToolset3D = filterAndOrderToolsByNamesList(toolsConfig, toolset3DOrderedNames);
  
  const toolset3D = filterToolsetBy3DConditions(filteredToolset3D, layout)
    .map((tool) => tool.name === toolNames.ANNOTATIONS
      ? {
        ...tool,
        options: mprAnnotationsOptions,
        disabled: layout.is3DModeEnabled && showVRToolCondition(layout),
      }
      : tool);

  return toolset3D;
};
